export enum NegotiationStatusEnum {
  OPENED = 'opened',
  CLOSED = 'closed',
  FAILED = 'failed',
}